class SndProductAddon extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.addonType;
    this.mainProductId = this.dataset.mainProductId;
    this.mainProductPrice = parseInt(this.dataset.mainProductPrice, 10);
    
    this.init();
  }

  init() {
    if (this.type === 'stringing' || this.type === 'overgrip') {
      this.initTabs();
      this.initSlider();
      this.initAddButton();
    } else if (this.type === 'free_gift') {
      this.initGiftButton();
    } else if (this.type === 'string_services') {
      this.initStringServices();
    }
  }

  initTabs() {
    this.radios = this.querySelectorAll('input[name^="addon_choice"]');
    this.drawer = this.querySelector('.snd-addon-drawer');
    this.addBtn = this.querySelector('[data-add-btn]');
    
    const productSection = this.closest('.shopify-section') || document;
    // Hide the entire form wrapper in Dawn-like themes so buy now and quantity selectors are hidden
    const nativeBuyButtonsElements = productSection.querySelectorAll('product-form-component, .product-form-buttons, .buy-buttons-block');

    const toggleNativeButtons = (value) => {
      nativeBuyButtonsElements.forEach(el => {
        if (value === 'add') {
          el.style.display = 'none';
        } else {
          el.style.display = '';
        }
      });
    };

    const initialChecked = this.querySelector('input[name^="addon_choice"]:checked');
    if (initialChecked) {
      toggleNativeButtons(initialChecked.value);
    }
    
    this.radios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.value === 'add') {
          this.drawer.style.display = 'block';
          this.updateButtonState();
        } else {
          this.drawer.style.display = 'none';
        }
        toggleNativeButtons(e.target.value);
      });
    });
  }

  initSlider() {
    this.itemRadios = this.querySelectorAll('input[name^="addon_variant"]');
    this.selectedInfo = this.querySelector('[data-selected-info]');
    this.selectedTitle = this.querySelector('[data-selected-title]');
    this.selectedPrice = this.querySelector('[data-selected-price]');
    this.slider = this.querySelector('.snd-addon-slider');
    this.changeBtn = this.querySelector('[data-change-btn]');
    
    this.itemRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const title = e.target.dataset.title;
        const priceCents = parseInt(e.target.dataset.price, 10);
        
        this.selectedTitle.textContent = title;
        this.selectedPrice.textContent = this.formatMoney(priceCents);
        this.selectedInfo.style.display = 'flex';
        this.slider.style.display = 'none'; // hide slider after selection
        
        this.updateButtonState();
      });
    });

    if (this.changeBtn) {
      this.changeBtn.addEventListener('click', () => {
        this.itemRadios.forEach(radio => radio.checked = false);
        this.selectedInfo.style.display = 'none';
        this.slider.style.display = 'flex';
        this.updateButtonState();
      });
    }

    const paidStringing = this.querySelector('input[name="paid_stringing"]');
    if (paidStringing) {
      paidStringing.addEventListener('change', () => this.updateButtonState());
    }
  }

  updateButtonState() {
    const selected = this.querySelector('input[name^="addon_variant"]:checked');
    const paidStringing = this.querySelector('input[name="paid_stringing"]');
    
    if (selected) {
      this.addBtn.disabled = false;
      let priceCents = parseInt(selected.dataset.price, 10);
      
      if (paidStringing && paidStringing.checked) {
        priceCents += parseInt(paidStringing.dataset.paidServicePrice, 10);
      }
      
      const total = this.mainProductPrice + priceCents;
      
      const typeText = this.type === 'stringing' ? 'String' : 'Grip';
      this.addBtn.textContent = `Add Racket + ${typeText} — ${this.formatMoney(total)}`;
    } else {
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Choose An Option';
    }
  }

  formatMoney(cents) {
    // Basic formatter for INR format, can be adapted based on Shopify's global money format
    return '₹ ' + (cents / 100).toLocaleString('en-IN');
  }

  initAddButton() {
    this.addBtn.addEventListener('click', async () => {
      const selected = this.querySelector('input[name^="addon_variant"]:checked');
      if (!selected) return;

      const tensionInput = this.querySelector('[data-input-tension]');
      const notesInput = this.querySelector('[data-input-notes]');
      
      const items = [];
      
      // 1. Add Main Product with Properties
      const mainProperties = {};
      if (tensionInput && tensionInput.value) {
        mainProperties['String Tension'] = tensionInput.value + ' LBS';
      }
      if (notesInput && notesInput.value) {
        mainProperties['Special Instructions'] = notesInput.value;
      }
      
      // Get the currently selected variant ID from the page instead of the static dataset
      let currentMainVariantId = this.mainProductId;
      const themeVariantInput = document.querySelector('input[name="id"]');
      if (themeVariantInput && themeVariantInput.value) {
        currentMainVariantId = themeVariantInput.value;
      }
      
      items.push({
        id: currentMainVariantId,
        quantity: 1,
        properties: mainProperties
      });
      
      // 2. Add Add-on Product
      items.push({
        id: selected.value,
        quantity: 1,
        properties: {
          '_LinkedTo': 'Main Product'
        }
      });
      
      const paidStringing = this.querySelector('input[name="paid_stringing"]');
      if (paidStringing && paidStringing.checked) {
        items.push({
          id: paidStringing.dataset.paidServiceId,
          quantity: 1,
          properties: {
            '_LinkedTo': 'Main Product'
          }
        });
      }

      this.addBtn.textContent = 'Adding...';
      this.addBtn.disabled = true;

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        if (res.ok) {
          window.location.href = window.Shopify.routes.root + 'cart';
        } else {
          const err = await res.json();
          alert('Failed to add to cart: ' + (err.description || 'Invalid variant selected.'));
          this.addBtn.textContent = 'Try Again';
          this.addBtn.disabled = false;
        }
      } catch (e) {
        console.error('Error adding to cart', e);
        this.addBtn.textContent = 'Error';
      }
    });
  }

  initGiftButton() {
    const giftBtn = this.querySelector('[data-add-gift]');
    if (!giftBtn) return;
    
    giftBtn.addEventListener('click', async () => {
      const giftId = giftBtn.dataset.giftId;
      
      const items = [
        { id: this.mainProductId, quantity: 1 },
        { id: giftId, quantity: 1, properties: { '_FreeGift': 'true' } }
      ];

      giftBtn.textContent = 'Adding...';
      giftBtn.style.opacity = '0.7';
      
      try {
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        giftBtn.textContent = 'Gift Added ✓';
        giftBtn.classList.add('added');
        // Optionally redirect to cart or open drawer
      } catch (e) {
        console.error('Error adding gift to cart', e);
        giftBtn.textContent = 'Error';
      }
    });
  }

  initStringServices() {
    const serviceCheckboxes = this.querySelectorAll('input[name^="service_variant"]');
    const addServicesBtn = this.querySelector('[data-add-services-btn]');
    if (!addServicesBtn) return;

    const getMainBasePrice = () => {
      let basePrice = parseInt(this.dataset.mainProductPrice, 10) || 0;
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        const activeOption = variantInput.querySelector('option:checked');
        if (activeOption && activeOption.dataset.price) {
          basePrice = parseInt(activeOption.dataset.price, 10) || basePrice;
        }
      }
      return basePrice;
    };

    const updateServicesButtonState = () => {
      const basePrice = getMainBasePrice();
      let extraCents = 0;
      let selectedCount = 0;

      serviceCheckboxes.forEach(cb => {
        if (cb.checked) {
          selectedCount++;
          extraCents += parseInt(cb.dataset.price, 10) || 0;
        }

        // Toggle card checked styling
        const cardBox = cb.closest('.snd-addon-service-card');
        if (cardBox) {
          if (cb.checked) {
            cardBox.classList.add('is-checked');
          } else {
            cardBox.classList.remove('is-checked');
          }
        }
      });

      const totalCents = basePrice + extraCents;

      if (selectedCount > 0) {
        addServicesBtn.textContent = `Add String + ${selectedCount} Service Add-on${selectedCount > 1 ? 's' : ''} — ${this.formatMoney(totalCents)}`;
      } else {
        addServicesBtn.textContent = `Add String to Cart — ${this.formatMoney(basePrice)}`;
      }
    };

    serviceCheckboxes.forEach(cb => {
      cb.addEventListener('change', updateServicesButtonState);
    });

    document.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id') {
        updateServicesButtonState();
      }
    });

    updateServicesButtonState();

    addServicesBtn.addEventListener('click', async () => {
      const tensionInput = this.querySelector('[data-input-tension]');
      const notesInput = this.querySelector('[data-input-notes]');

      const items = [];

      // 1. Main Product
      const mainProperties = {};
      if (tensionInput && tensionInput.value) {
        mainProperties['String Tension'] = tensionInput.value + ' LBS';
      }
      if (notesInput && notesInput.value) {
        mainProperties['Special Instructions'] = notesInput.value;
      }

      let currentMainVariantId = this.mainProductId;
      const themeVariantInput = document.querySelector('input[name="id"]');
      if (themeVariantInput && themeVariantInput.value) {
        currentMainVariantId = themeVariantInput.value;
      }

      items.push({
        id: currentMainVariantId,
        quantity: 1,
        properties: mainProperties
      });

      // 2. Selected Service Variants
      serviceCheckboxes.forEach(cb => {
        if (cb.checked) {
          items.push({
            id: cb.value,
            quantity: 1,
            properties: {
              '_LinkedTo': 'Main Product'
            }
          });
        }
      });

      addServicesBtn.textContent = 'Adding...';
      addServicesBtn.disabled = true;

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (res.ok) {
          window.location.href = window.Shopify.routes.root + 'cart';
        } else {
          const err = await res.json();
          alert('Failed to add to cart: ' + (err.description || 'Invalid selection.'));
          addServicesBtn.textContent = 'Try Again';
          addServicesBtn.disabled = false;
        }
      } catch (e) {
        console.error('Error adding string services to cart', e);
        addServicesBtn.textContent = 'Error';
        addServicesBtn.disabled = false;
      }
    });
  }
}

customElements.define('snd-product-addon', SndProductAddon);
